import { BreadcrumbProps } from '@carvana/ds-breadcrumb';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import { Consumer } from '~/constants/common/consumer';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useAnalyticsId } from '~/context/vdp/SectionAnalyticsContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import useMakeParentModelSearchLink from './useMakeParentModelSearchLink';
import useMakeSearchLink from './useMakeSearchLink';

type BreadCrumbType = Array<
  BreadcrumbProps['crumbs'][number] & { key: string }
>;

const getHref = getHrefWithSource(Consumer.VDP);

export default function useParentModelBreadcrumbs(): BreadCrumbType {
  const { trackEvent } = useContext(AnalyticsContext);
  const { make = '', parentModel = '' } = useGetVehicleDetails();
  const isMobile = useIsMobile();
  const makeSearchLink = useMakeSearchLink();
  const makeModelSearchLink = useMakeParentModelSearchLink();
  const analyticsId = useAnalyticsId();

  const handleClick = useCallback(
    (description: string, text: string) => {
      if (analyticsId) {
        trackEvent(analyticsId, { action: 'clicked', description, text });
      }
    },
    [analyticsId, trackEvent]
  );

  return [
    {
      href: getHref('/cars'),
      key: 'all-cars',
      label: isMobile ? 'All' : 'All Cars',
      onClick: () => handleClick('all', isMobile ? 'All' : 'All Cars')
    },
    {
      href: getHref(makeSearchLink),
      key: 'make',
      label: make,
      onClick: () => handleClick('make', make)
    },
    {
      href: getHref(makeModelSearchLink),
      key: 'model',
      label: parentModel,
      onClick: () => handleClick('model', parentModel)
    }
  ];
}
